import { FC } from 'react'
import Typography from '@/ui/components/typography'
import WarningTriangleIcon from '@/assets/images/warning-triangle.svg?react'
import { CustomTooltip } from '@atbay/component-lib'
import {
    OverviewListItemContainer,
    IconContainer,
    ContentContainer,
    TitleContainer,
    SubtitleTypography,
    MonitoringStatsCount,
    SubtitleContainer,
    AlertIcon,
    AlertIconWrapper,
} from './OverviewListItem.styles'
import { OverviewListItemProps } from './OverviewListItem.types'
import { useCustomTheme } from '@/core/theme'
import { ConnectionStatus } from './ConnectionStatus'

const OverviewListItem: FC<OverviewListItemProps> = ({
    id,
    icon,
    title,
    subtitle,
    isActive,
    hasConnectionError,
    monitoringStatsCount,
    showConnectionStatus = true,
    showIconBackground = true,
    onClick,
    isLoading,
    alertCount,
    alertTooltipText,
}) => {
    const theme = useCustomTheme()

    return (
        <OverviewListItemContainer>
            <IconContainer
                isActive={isActive}
                showIconBackground={showIconBackground}
            >
                {icon}
            </IconContainer>
            <ContentContainer>
                <TitleContainer isActive={isActive}>
                    <Typography
                        variant="s-regular"
                        testId={`overview-list-item-title-${id}`}
                        noWrap={false}
                    >
                        {monitoringStatsCount !== undefined && (
                            <MonitoringStatsCount
                                data-testid={`overview-list-item-monitoring-stats-count-${id}`}
                            >
                                {monitoringStatsCount}
                            </MonitoringStatsCount>
                        )}{' '}
                        {title}
                    </Typography>
                </TitleContainer>
                <SubtitleContainer>
                    <SubtitleTypography
                        isActive={isActive}
                        variant="xs-regular"
                        color={theme.colors.greys[500]}
                        data-testid={`overview-list-item-subtitle-${id}`}
                    >
                        {subtitle}
                    </SubtitleTypography>
                    {!!alertCount && (
                        <CustomTooltip
                            title={alertTooltipText}
                            placement="top"
                            alwaysShowOnHover={!!alertTooltipText}
                        >
                            <AlertIcon
                                data-testid={`overview-list-item-alert-${id}`}
                            >
                                <AlertIconWrapper>
                                    <WarningTriangleIcon color={theme.colors.semantic.error} />
                                </AlertIconWrapper>
                                {alertCount}
                            </AlertIcon>
                        </CustomTooltip>
                    )}
                </SubtitleContainer>
                {showConnectionStatus && (
                    <ConnectionStatus
                        id={id}
                        isActive={isActive}
                        hasConnectionError={hasConnectionError}
                        onClick={onClick}
                        isLoading={isLoading}
                    />
                )}
            </ContentContainer>
        </OverviewListItemContainer>
    )
}

export default OverviewListItem
